<div class="presentation-wrapper">
  <!-- Left Side Branding Section -->
  <div class="branding-section">
    <img src="assets/prim-green-wall.png" alt="Prim Diet Branding" class="brand-wall-img" />
  </div>

  <!-- Right Side Mobile App Frame (Google Pixel 9) -->
  <div class="phone-container">
    <ion-app>
      <ion-router-outlet
        [ngClass]="{ 'safe-area': isSafe, 'is-android': isAndroid }"
      ></ion-router-outlet>
      <currency-change></currency-change>

      @if (onLogin && currentURL !== 'terms' && currentURL !== 'welcome' && !isAIOrg) {
        <ion-fab
          slot="fixed"
          vertical="bottom"
          horizontal="end"
          class="chat_floating_button"
          color="primary"
          (mousedown)="onDragStart($event)"
          (mousemove)="onDrag($event)"
          (mouseup)="onDragEnd($event)"
          (touchstart)="onDragStart($event)"
          (touchmove)="onDrag($event)"
          (touchend)="onDragEnd($event)"
        >
          <ion-fab-button>
            <ion-icon name="chevron-up-circle-outline" class="text-light"></ion-icon>
          </ion-fab-button>

          <ion-fab-list side="top">
            @for (bookmark of bookmarks; track bookmark.bookmark_name) {
              @if (['instagram_link', 'facebook_link', 'linkedin_link', 'youtube_link', 'twitter_link', 'website_link'].includes(bookmark.bookmark_name) && bookmark.bookmark) {
                <ion-fab-button color="light" (click)="openLink(bookmark.bookmark)">
                  <ion-icon
                    [name]="
                      bookmark.bookmark_name === 'instagram_link'
                        ? 'logo-instagram'
                        : bookmark.bookmark_name === 'facebook_link'
                        ? 'logo-facebook'
                        : bookmark.bookmark_name === 'linkedin_link'
                        ? 'logo-linkedin'
                        : bookmark.bookmark_name === 'youtube_link'
                        ? 'logo-youtube'
                        : bookmark.bookmark_name === 'twitter_link'
                        ? 'logo-twitter'
                        : bookmark.bookmark_name === 'website_link'
                        ? 'earth-outline'
                        : 'link-outline'
                    "
                  ></ion-icon>
                </ion-fab-button>
              }
            }

            <ion-fab-button (click)="openChatModal()">
              <ion-icon name="chatbubble-ellipses"></ion-icon>
            </ion-fab-button>
          </ion-fab-list>
        </ion-fab>
      }
    </ion-app>
  </div>
</div>
